import type { Notification as AppNotification } from '../types/notifications'

/**
 * Request browser notification permission
 */
export async function requestNotificationPermission(): Promise<NotificationPermission> {
  if (!('Notification' in window)) {
    console.warn('This browser does not support desktop notification')
    return 'denied'
  }

  if (Notification.permission === 'granted') {
    return 'granted'
  }

  if (Notification.permission === 'denied') {
    return 'denied'
  }

  return Notification.requestPermission()
}

/**
 * Show a browser notification
 */
export function showBrowserNotification(notification: AppNotification) {
  if (!('Notification' in window)) {
    console.warn('This browser does not support desktop notification')
    return
  }

  if (Notification.permission !== 'granted') {
    console.warn('Notification permission not granted')
    return
  }

  const options: NotificationOptions = {
    body: notification.message ?? '',
    icon: '/icon.svg',
    badge: '/icon.svg',
    tag: notification.id,
    data: {
      url: notification.action_url || '/',
      notificationId: notification.id,
    },
  }

  // Use service worker if available
  if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
    navigator.serviceWorker.controller.postMessage({
      type: 'SHOW_NOTIFICATION',
      payload: {
        title: notification.title,
        options,
      },
    })
  } else {
    // Fallback to direct notification
    const browserNotification = new Notification(notification.title, options)

    browserNotification.onclick = function (event) {
      event.preventDefault()
      if (notification.action_url) {
        window.open(notification.action_url, '_blank')
      }
      browserNotification.close()
    }
  }
}

